export default __webpack_public_path__ + "static/media/Loading.752fa927.gif";